module.exports = __webpack_public_path__ + "static/media/facebook.61a241bc.svg";